module.exports = __webpack_public_path__ + "img/t5-blue.cd6c50e0.png";